import { RightOutlined } from '@ant-design/icons';
import { Collapse, CollapseProps, Typography } from 'antd';

const { Text } = Typography;

export type FormOfferCollapseProps = {
  activeKeys: string[];
  items: CollapseProps['items'];
  onUpdateActiveKeys: (key: string, open: boolean) => void;
};
export const FormOfferCollapse = ({
  items,
  activeKeys,
  onUpdateActiveKeys,
}: FormOfferCollapseProps) => {
  return (
    <Collapse
      ghost
      size='large'
      activeKey={activeKeys}
      style={{ paddingBlockEnd: '82px' }}
      expandIcon={({ isActive }) => (
        <RightOutlined
          style={{
            marginInlineStart: -8,
            transform: isActive ? 'rotate(90deg)' : 'none',
            transition: 'transform 0.2s',
          }}
        />
      )}
      items={items?.map(({ key, children, label, ...rest }) => ({
        key,
        style: {
          borderTop: '1px solid #333',
          borderRadius: '0',
        },
        label: (
          <Text
            style={{
              fontSize: '20px',
              fontWeight: 600,
              lineHeight: '28px',
            }}
          >
            {label}
          </Text>
        ),
        styles: {
          header: {
            padding: '24px 0',
          },
          body: {
            padding: '0px',
            paddingBlockEnd: '24px',
          },
        },
        children: <div onClick={e => e.stopPropagation()}>{children}</div>,
        onClick: () => {
          if (rest.collapsible === 'disabled') return;
          const isActive = activeKeys.includes(String(key));
          onUpdateActiveKeys(String(key), !isActive);
        },
        ...rest,
      }))}
    />
  );
};
